


















































































































































































































import Vue from "vue";

import { XMLValidator } from "fast-xml-parser";
import { prettyXml } from "@/utility/Formatter";

import { GetDataFlowFailedMessageCommand } from "@/model/communication/dataFlow/GetDataFlowFailedMessageCommand";
import { GetDataFlowFailedMessageResData } from "@/model/communication/dataFlow/GetDataFlowFailedMessageResData";
import { PostDataFlowModifyMessageCommand } from "@/model/communication/dataFlow/PostDataFlowModifyMessageCommand";
import { PostDataFlowSkipFailedMessageCommad } from "@/model/communication/dataFlow/PostDataFlowSkipFailedMessageCommad";
import { PostDataFlowRetryFailedMessageCommad } from "@/model/communication/dataFlow/PostDataFlowRetryFailedMessageCommad";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";

export default Vue.extend({
    props: {
        installationName: String,
        converterType: String,
    },
    data() {
        return {
            failedMessage: null,
            failedMessageRayId: null,
            localFailedMessage: null,
            loading: false,
            noFailedMessage: true,
            showEditedAlert: false,
            showEditedAlertError: false,
            canCopy: window.isSecureContext,
            copyIcon: "copy",
            showSkippedAlert: false,
            showSkippedAlertError: false,
            skippedAlertErrorMessage: null,
            showGetFailedMessageError: false,
            getFailedMessageError: null,
            editedAlertError: null,
            showParsingError: false,
            parsingError: null,
            showSkipDialog: false,
            showEditDialog: false,
            showRetryDialog: false,
            showRetryAlert: false,
            showRetryAlertError: false,
            retryAlertErrorMessage: null,
        };
    },
    watch: {
        installationName: {
            handler() {
                if (this.installationName) {
                    this.resetData();
                    this.getFailedMessage();
                }
            },
            immediate: true,
        },
        converterType() {
            this.resetData();
            this.getFailedMessage();
        },
    },
    computed: {
        canSend() {
            return this.localFailedMessage != this.failedMessage;
        },
    },
    methods: {
        prettyXml,
        resetData() {
            this.failedMessage = null;
            this.failedMessageRayId = null;
            this.localFailedMessage = null;
            this.noFailedMessage = true;
            this.resetAlert();
        },
        resetAlert() {
            this.showEditedAlert = false;
            this.showEditedAlertError = false;
            this.showSkippedAlert = false;
            this.showSkippedAlertError = false;
            this.skippedAlertErrorMessage = null;
            this.showGetFailedMessageError = false;
            this.getFailedMessageError = null;
            this.editedAlertError = null;
            this.showParsingError = false;
            this.parsingError = null;
            this.showSkipDialog = false;
            this.showRetryDialog = false;
            this.showEditDialog = false;
            this.showRetryAlert = false;
            this.showRetryAlertError = false;
            this.retryAlertErrorMessage = null;
        },
        reset() {
            this.localFailedMessage = this.failedMessage;
            this.showParsingError = false;
            this.parsingError = null;
        },
        async copyAll() {
            await navigator.clipboard.writeText(this.localFailedMessage);
            this.copyIcon = "check";
            setTimeout(() => {
                this.copyIcon = "copy";
            }, 1000);
        },
        selectAll() {
            let inputEl = this.$refs.textarea.$el.querySelector("textarea");
            console.log(this.$refs.textarea.$el);
            setTimeout(() => {
                inputEl.select();
            }, 200);
        },
        validateXml() {
            const result = XMLValidator.validate(this.localFailedMessage, {
                allowBooleanAttributes: false,
            });
            if (result == true) {
                this.showEditDialog = true;
                this.showParsingError = false;
                this.parsingError = null;
            } else {
                this.showParsingError = true;
                this.parsingError = `${result.err.msg}. Line: ${result.err.line} Col: ${result.err.col}`;
            }
        },
        async getFailedMessage() {
            this.loading = true;
            try {
                let response: GetDataFlowFailedMessageResData = await new GetDataFlowFailedMessageCommand(this.installationName, this.converterType).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.failedMessage) {
                    this.failedMessage = this.prettyXml(response.failedMessage);
                    this.localFailedMessage = this.failedMessage;
                    this.failedMessageRayId = response.rayId;
                    this.noFailedMessage = false;
                } else {
                    this.resetData();
                    if (response.responseString == "GenericError" && response.message != "No failed message found") {
                        this.showGetFailedMessageError = true;
                        this.getFailedMessageError = response.message;
                    }
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowFailedMessageCommand request ", e);
            }
            this.loading = false;
        },
        async editRemoteMessage() {
            this.resetAlert();
            this.showEditDialog = false;
            this.loading = true;
            try {
                let response: ApiGenericResponse = await new PostDataFlowModifyMessageCommand(this.failedMessageRayId, this.localFailedMessage).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && !response.message) {
                    this.resetData();
                    this.showEditedAlert = true;
                } else {
                    this.showEditedAlertError = true;
                    this.editedAlertError = response.message;
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowFailedMessageCommand request ", e);
            }
            this.loading = false;
        },

        async skipMessage() {
            this.resetAlert();
            this.showSkipDialog = false;
            this.loading = true;
            try {
                let response: ApiGenericResponse = await new PostDataFlowSkipFailedMessageCommad(this.installationName, this.converterType).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && !response.message) {
                    this.resetData();
                    this.showSkippedAlert = true;
                } else {
                    this.showSkippedAlertError = true;
                    this.skippedAlertErrorMessage = response.message;
                }
            } catch (e) {
                console.log("Something went wrong sending PostDataFlowSkipFailedMessageCommad request ", e);
            }
            this.loading = false;
        },

        async retryMessage() {
            this.resetAlert();
            this.showRetryDialog = false;
            this.loading = true;
            try {
                let response: ApiGenericResponse = await new PostDataFlowRetryFailedMessageCommad(this.installationName, this.converterType).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && !response.message) {
                    this.resetData();
                    this.showRetryAlert = true;
                } else {
                    this.showRetryAlertError = true;
                    this.retryAlertErrorMessage = response.message;
                }
            } catch (e) {
                console.log("Something went wrong sending PostDataFlowRetryFailedMessageCommad request ", e);
            }
            this.loading = false;
        },
    },
    mounted() {
        window.addEventListener("reload-remote-message-editor-card", () => {
            this.resetData();
            this.getFailedMessage();
        });
    },
});
